const IgIntro = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16.92 16.92' {...props}>
    <g>
      <circle cx='8.46' cy='8.46' r='2.95' />
      <path d='M16.87 5a6.16 6.16 0 0 0-.39-2 4.19 4.19 0 0 0-1-1.5 4.19 4.19 0 0 0-1.5-1 6.1 6.1 0 0 0-1.98-.45h-3.49s-2.64-.05-3.51 0a6.16 6.16 0 0 0-2 .39 4.19 4.19 0 0 0-1.5 1 4.19 4.19 0 0 0-1 1.5 6.16 6.16 0 0 0-.45 2.06v3.49s-.05 2.56 0 3.51a6.1 6.1 0 0 0 .39 2 4.19 4.19 0 0 0 1 1.5 4.19 4.19 0 0 0 1.5 1 6.16 6.16 0 0 0 2.06.37c.9 0 1.19.05 3.49.05s2.59 0 3.49-.05a6.1 6.1 0 0 0 2.02-.39 4.37 4.37 0 0 0 2.48-2.48 6.1 6.1 0 0 0 .39-2c0-.9.05-1.19.05-3.49s-.01-2.64-.05-3.51zm-8.41 8a4.54 4.54 0 1 1 4.54-4.54 4.54 4.54 0 0 1-4.54 4.54zm4.72-8.2a1.06 1.06 0 1 1 1.06-1.06 1.05 1.05 0 0 1-1.06 1.06z' />
    </g>
  </svg>
)

export default IgIntro



// WEBPACK FOOTER //
// ./components/icons/ig-intro.js